import Template from './loader.html';

export default {
	name: 'Loader',
	template: Template
};



// WEBPACK FOOTER //
// ./src/loader/loader.js